/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA,
  LOAD_CASH_BANK_DETAILS,
  CREATE_CASH_BANK_DETAILS,
  UPDATE_CASH_BANK_DETAILS,
  DELETE_CASH_BANK_DETAILS,
  LOAD_CASH_BANK_TOTAL_LIST,
  LOAD_CASH_IN_HAND_TRANSACTION,
  LOAD_ACCOUNT_TRANSACTION_DETAILS,
  LOAD_CASH_IN_HAND_LIST,
  LOAD_TOTAL_CASH_BANK_TRANSACTION,
} from "./constants";

import {
  loadCashBankList,
  loadCashBankListSuccess,
  loadCashBankListError,
  createCashBankListSuccess,
  createCashBankListError,
  updateCashBankListSuccess,
  updateCashBankListError,
  deleteCashBankListSuccess,
  deleteCashBankListError,
  loadCashBankListRecordsMetaDataError,
  loadCashBankListRecordsMetaDataSuccess,
  loadCashBankTotalList,
  loadCashBankTotalListSuccess,
  loadCashBankTotalListError,
  loadCashInHandTransaction,
  loadCashInHandTransactionSuccess,
  loadCashInHandTransactionError,
  loadAccountTransactionList,
  loadAccountTransactionListSuccess,
  loadAccountTransactionListError,
  loadCashInHandList,
  loadCashInHandListSuccess,
  loadCashInHandListError,
  loadTotalCashBankTransaction,
  loadTotalCashBankTransactionSuccess,
  loadTotalCashBankTransactionError,
} from "./actions";

import {
  loadCashBankDetails,
  createCashBankDetails,
  updateCashBankDetails,
  deleteCashBankDetails,
  loadRecordsMetaData,
  loadCashBankTotalDetails,
  loadAccountTransactionDetails,
  loadCashInHandDetails,
  loadCashInHandTransactionDetails,
  loadTotalCashBankTransactionDetails,
} from "./remotes";

function* loadCashBankListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CASH_BANK_DETAILS),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadCashBankList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCashBankDetails, paymentDetails);

        if (result) {
          yield put(loadCashBankListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCashBankListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadAccountTransactionListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ACCOUNT_TRANSACTION_DETAILS),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadAccountTransactionList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadAccountTransactionDetails,
          paymentDetails
        );

        if (result) {
          yield put(loadAccountTransactionListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadAccountTransactionListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadCashBankTotalDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CASH_BANK_TOTAL_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadCashBankTotalList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCashBankTotalDetails, paymentDetails);

        if (result) {
          yield put(loadCashBankTotalListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCashBankTotalListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTotalCashBankTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_TOTAL_CASH_BANK_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadTotalCashBankTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadTotalCashBankTransactionDetails,
          paymentDetails
        );

        if (result) {
          yield put(loadTotalCashBankTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTotalCashBankTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadCashInHandTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CASH_IN_HAND_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadCashInHandTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadCashInHandTransactionDetails,
          paymentDetails
        );

        if (result) {
          yield put(loadCashInHandTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCashInHandTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadCashInHandListSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CASH_IN_HAND_LIST),
    });

    const { explicitLoad } = load;
    const { paymentDetails } = explicitLoad || {};
    yield put(loadCashInHandList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCashInHandDetails, paymentDetails);

        if (result) {
          yield put(loadCashInHandListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadCashInHandListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_CASH_BANK_DETAILS),
    });

    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(createCashBankDetails, paymentDetails);
        if (result) {
          yield put(createCashBankListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createCashBankListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePaymentSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_CASH_BANK_DETAILS),
    });
    const { paymentDetails } = update || {};

    if (update) {
      try {
        const result = yield call(updateCashBankDetails, paymentDetails);
        if (result) {
          yield put(updateCashBankListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updateCashBankListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePaymentSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_CASH_BANK_DETAILS),
    });
    const { paymentDetails } = create || {};

    if (create) {
      try {
        const result = yield call(deleteCashBankDetails, paymentDetails);
        if (result) {
          yield put(deleteCashBankListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deleteCashBankListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadCashBankDetailsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_CASH_BANK_DETAILS_RECORDS_META_DATA),
    });

    try {
      const paymentMode = yield call(
        loadRecordsMetaData,
        "getpaymentmode",
        "post"
      );

      let recordsMetaData = {
        paymentModeOptions:
          (paymentMode &&
            paymentMode &&
            paymentMode.length > 0 &&
            paymentMode.map((c) =>
              Object.assign(
                {},
                {
                  label: c.paymentModeName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      };

      yield put(loadCashBankListRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadCashBankListRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadCashBankListSaga(),
    deletePaymentSaga(),
    updatePaymentSaga(),
    createPaymentSaga(),
    loadCashBankTotalDetailsSaga(),
    loadCashInHandTransactionSaga(),
    loadCashBankDetailsMetaDataSaga(),
    loadAccountTransactionListSaga(),
    loadCashInHandListSaga(),
    loadTotalCashBankTransactionSaga(),
  ]);
}
